// extracted by mini-css-extract-plugin
export default {"root":"_1_aQr3a4tgLRTskGfIjHhz","searchParamLabel":"_1XXsTdXnEPqn-4DspISbgV","submitSearchButton":"_140jta7yRNXsfCHjHn0lWt button success"};